"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildClient = void 0;
var node_fetch_1 = require("node-fetch");
var apollo_boost_1 = require("apollo-boost");
var apollo_link_http_1 = require("apollo-link-http");
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var config_1 = require("../config");
var httpLink = apollo_link_http_1.createHttpLink({
    uri: config_1.graphUrl,
    fetch: node_fetch_1.default
});
var buildClient = function (args) {
    var token = args.token;
    var authLink = new apollo_boost_1.ApolloLink(function (operation, forward) {
        operation.setContext({
            headers: {
                Authorization: token ? "Bearer " + token : ''
            }
        });
        return forward(operation);
    });
    return new apollo_client_1.default({
        cache: new apollo_cache_inmemory_1.InMemoryCache(),
        defaultOptions: {
            query: {
                fetchPolicy: 'no-cache'
            }
        },
        link: authLink.concat(httpLink)
    });
};
exports.buildClient = buildClient;
//# sourceMappingURL=index.js.map